import { render, staticRenderFns } from "./PID.vue?vue&type=template&id=23c577fc"
import script from "./PID.vue?vue&type=script&lang=js"
export * from "./PID.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports